import { render, staticRenderFns } from "./AddCollectionItemModal.vue?vue&type=template&id=0a2c184d&scoped=true&"
import script from "./AddCollectionItemModal.vue?vue&type=script&lang=js&"
export * from "./AddCollectionItemModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCollectionItemModal.vue?vue&type=style&index=0&id=0a2c184d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c184d",
  null
  
)

export default component.exports